/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Quote_StaleInputs */

const vi_carrier_form_quote_stale = /** @type {(inputs: Carrier_Form_Quote_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin kiện hàng đã thay đổi — cần lấy báo giá lại`)
};

/**

* @param {Carrier_Form_Quote_StaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_quote_stale = /** @type {((inputs?: Carrier_Form_Quote_StaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Quote_StaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_quote_stale(inputs)
});